import { render } from "./FixView.vue?vue&type=template&id=77642485&scoped=true"
import script from "./FixView.vue?vue&type=script&lang=js"
export * from "./FixView.vue?vue&type=script&lang=js"

import "./FixView.vue?vue&type=style&index=0&id=77642485&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77642485"]])

export default __exports__